module.exports = __webpack_public_path__ + "img/arsenal_small.40d60c7e.png";